/**
 * SRCartRefresh — den gemensamma vägen för att rita om varukorgen efter en
 * mutation. Före konsolideringen fanns samma sektionsswap kopierad i fyra
 * skript (cart-add-intercept, sr-cart-reco, GWP-snippeten, cart-sample) som
 * körde oberoende av varandra; ett enda köp kunde ge tre överlappande
 * innerHTML-swappar av samma noder — flimret, och lyssnare som försvann.
 *
 * Kontraktet:
 *   window.SRCartRefresh.refresh()  → Promise. Anrop serialiseras i en kö;
 *     kommer ett nytt anrop medan ett kör körs EN uppföljning när det första
 *     är klart (fler än så kollapsas — sista vinner, staten hämtas ändå färsk).
 *   Efter varje genomförd swap skickas `sr:cart-refreshed` på document, så
 *     skript som behöver reagera (GWP-sync, upsell) lyssnar i stället för att
 *     patcha window.fetch själva.
 *
 * Temats egna vägar i theme.js (qty-ändring, gift wrap) är INTE konverterade —
 * theme.js delas med resten av temat och lämnas orörd i detta steg.
 */
(function () {
  'use strict';
  if (window.SRCartRefresh) return;

  var running = false;
  var queued = false;
  var waiters = [];

  function swapSections() {
    var ids = [];
    var drawerEl = document.querySelector('[cart-drawer-section]');
    var drawerId = drawerEl ? drawerEl.dataset.id || 'cart-drawer' : null;
    if (drawerId) ids.push(drawerId);

    var mainCart = document.getElementById('main-cart');
    var mainSectionId = null;
    if (mainCart) {
      var pageSection = mainCart.closest('[data-section]');
      if (pageSection && pageSection.dataset.section) {
        mainSectionId = pageSection.dataset.section;
        ids.push(mainSectionId);
      }
    }
    if (!ids.length) return Promise.resolve();

    return fetch('/?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawerId && sections[drawerId]) {
          var doc = new DOMParser().parseFromString(sections[drawerId], 'text/html');
          ['[data-cart-drawer-body]', '[data-cart-drawer-header]', '[data-cart-drawer-content]'].forEach(function (sel) {
            var n = doc.querySelector(sel);
            var o = document.querySelector(sel);
            if (n && o) o.innerHTML = n.innerHTML;
          });
        }
        if (mainSectionId && sections[mainSectionId] && mainCart) {
          var doc2 = new DOMParser().parseFromString(sections[mainSectionId], 'text/html');
          var newContent = doc2.querySelector('.main--cart-render');
          var oldContent = document.querySelector('.main--cart-render');
          if (newContent && oldContent) oldContent.innerHTML = newContent.innerHTML;
        }
        // Badge — läses ur den nyss inswappade DOM:en (inte den gamla).
        var fresh = document.querySelector('[data-cart-items]');
        var badge = document.querySelector('[data-cart-count]');
        if (fresh && badge) {
          var count = fresh.dataset.cartItems;
          if (!count || count === '0') {
            badge.classList.add('hidden');
            badge.textContent = '';
          } else {
            badge.classList.remove('hidden');
            badge.textContent = parseInt(count, 10) > 99 ? '' : count;
          }
        }
        document.dispatchEvent(new CustomEvent('sr:cart-refreshed'));
      });
  }

  function drain() {
    running = true;
    // Fånga väntarna INNAN swappen startar. Den som köar sig medan swappen
    // pågår ska lösas av uppföljningen (som ser dess mutation), inte av den
    // pågående som hämtade state före mutationen.
    var resolvers = waiters;
    waiters = [];
    swapSections()
      .catch(function () {})
      .then(function () {
        resolvers.forEach(function (fn) { fn(); });
        if (queued) {
          queued = false;
          drain();
        } else {
          running = false;
        }
      });
  }

  window.SRCartRefresh = {
    refresh: function () {
      return new Promise(function (resolve) {
        waiters.push(resolve);
        if (running) { queued = true; return; }
        drain();
      });
    },
    openDrawer: function () {
      var drawer = document.querySelector('cart-drawer, [data-cart-drawer]');
      if (!drawer) return;
      var sideDrawer = drawer.closest('.side-drawer') || document.querySelector('.side-drawer.cart-drawer-side');
      if (sideDrawer && !sideDrawer.classList.contains('show')) {
        sideDrawer.classList.add('show');
        document.documentElement.classList.add('drawer-open');
      }
    }
  };
})();
